import React, { useEffect } from 'react';
import {IProps} from './types';
import { Shape } from 'react-konva';

const CustomTextElement: React.FC<IProps> = (props) => {
    return (
        <>
        {
            <Shape
                name={props.name}
                key={props.id}
                id={props.id}
                x={props.x}
                y={props.y}
                height={props.height}
                visible={props.visible}
                opacity={props.opacity}
                sceneFunc={(context, shape) => { 
                    const size: string = (props.fontSize.toString() + "px ");  
                    const family: string = (props.fontFamily?(props.fontFamily.replaceAll("'","").replaceAll("\"","")):"");  
                    const italic: string = (props.fontItalic?"italic ":"");  
                    const bold: string = (props.fontBold?"bold ":"");  
                    context.setAttr("font", italic + bold + size + family);
                    context.setAttr("textBaseline", "alphabetic");
                    context.setAttr("textAlign", "left");
                    context.setAttr("fillStyle", props.fill);
                    const measure = context.measureText(props.text ?? "");
                    const width = measure.width + ((props.text??"").length*(((props.letterSpacing??0)/100)));
                    if (props.letterSpacing && props.text) {
                        let spaceCount=0;
                        for (let i=0;i<props.text.length;i++) {
                            const character = props.text.substring(i,i+1);
                            context.fillText(character,spaceCount,0);
                            const measureCharacter = context.measureText(character);
                            spaceCount += measureCharacter.width + ((props.letterSpacing??0)/100);
                        }
                    }
                    else {
                        context.fillText(props.text??"",0,0);
                    }
                    const lineWidth = (props.fontSize/13);
                    if (props.fontUnderline && props.text && props.text.replaceAll("\n","") !== "") {
                        const underlineYPosition = 1 + lineWidth;
                        context.beginPath();
                        context.moveTo(
                          0,
                          underlineYPosition
                        );
                        context.lineTo(
                            width, 
                            underlineYPosition
                        );
                        context.setAttr("lineWidth", lineWidth);
                        context.setAttr("strokeStyle", props.fill);
                        context.stroke();
                      }
                }}    
            />
        }
        </>
    );
}

export default CustomTextElement;